import { render, staticRenderFns } from "./RegistrationFormAgreement.vue?vue&type=template&id=088196a6&"
import script from "./RegistrationFormAgreement.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RegistrationFormAgreement.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('088196a6')) {
      api.createRecord('088196a6', component.options)
    } else {
      api.reload('088196a6', component.options)
    }
    module.hot.accept("./RegistrationFormAgreement.vue?vue&type=template&id=088196a6&", function () {
      api.rerender('088196a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/RegistrationForm/components/RegistrationFormAgreement.vue"
export default component.exports